<template>
    <div class="background">
        <div style="width: 90%;margin: 0 auto;">
            <van-row style="margin: 1rem 0;">
                <van-col span="8">
                    <van-button v-if="jobInfo22" class="button22" :url="jobInfo22.jobLink"></van-button>
                </van-col>
                <van-col span="8">
                    <van-button v-if="jobInfo70" class="button70" :url="jobInfo70.jobLink"></van-button>
                </van-col>
                <van-col span="8">
                    <van-button v-if="jobInfo6" class="button6" :url="jobInfo6.jobLink"></van-button>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import constantAPI from '@/api/constant';
    import wxShare from '@/utils/wxShareService';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                },
                jobInfo22: null,
                jobInfo70: null,
                jobInfo6: null,
            }
        },
        methods: {
        },
        created() {
            document.title = "京东组合拉新";
            if (!this.query.traderId) {
                return;
            }

            mainAPI.getInfoByTraderId(22, this.query.traderId).then((result) => {
                this.jobInfo22 = result.data;
            }).catch(() => {
            });

            mainAPI.getInfoByTraderId(70, this.query.traderId).then((result) => {
                this.jobInfo70 = result.data;
            }).catch(() => {
            });

            mainAPI.getInfoByTraderId(6, this.query.traderId).then((result) => {
                this.jobInfo6 = result.data;
            }).catch(() => {
            });
        },
        mounted() {
            let shareInfo = {
                "imgUrl": "http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O05KE2O.png",
                "title": "京东组合拉新",
                "desc": "京东组合拉新",
                "link": window.location.href,
            };
            constantAPI.weChatShareConfig(shareInfo.link).then((result) => {
                wxShare.setWxConfig(result.data);
                wxShare.setShare(shareInfo);
            });
            pvuvAPI.addPv("baiTiaoShopping/union", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        background-image: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NsdPcRG.jpg');
        background-size: 100% 100%;
        height: 52rem;
        text-align: center;
        padding-top: 20rem;
    }

    .button22 {
        width: 8rem;
        height: 8rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NsibGvO.png");
        background-size: 100% 100%;
        border-style: none;
        border-radius: 5rem;
    }

    .button70 {
        width: 8rem;
        height: 8rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NsibGvJ.png");
        background-size: 100% 100%;
        border-style: none;
        border-radius: 5rem;
    }

    .button6 {
        width: 8rem;
        height: 8rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NsibGvL.png");
        background-size: 100% 100%;
        border-style: none;
        border-radius: 5rem;
    }

</style>
